import { formatCurrency, getCurrencySymbol } from "@angular/common";

export const formatCurrencyDE = (value: number, currencyCode: string = "EUR", digitsInfo: string = "1.0"): string => {
  const currency = getCurrencySymbol(currencyCode, "wide", "de-DE");
  return formatCurrency(value, "de-DE", currency, currencyCode, digitsInfo);
};
